<template>
  <el-upload
    class="uploadContent"
    :action="domain + action"
    :headers="headers"
    :show-file-list="false"
    accept="video/*"
    :before-upload="beforeUploadVideo"
    :data="uploadOtherData"
    :on-progress="uploadVideoProcess"
    name="video"
    :on-success="uploadVideo"
    :disabled="disabled"
  >
    <div class="upload" v-if="result !=='' && !videoFlag">
      <video :src="showVideoUrl" controls="controls">您的浏览器不支持视频播放</video>
    </div>
    <div v-if="result === '' && !videoFlag" class="upload">+{{ description }}</div>
    <el-progress v-if="videoFlag" type="circle" :percentage="videoUploadPercent" style="margin-top:30px;"></el-progress>
    <el-button slot="trigger" v-if="result !=='' && !videoFlag && isFirefox" type="primary" size="small" :disabled="disabled">重新上传</el-button>
  </el-upload>
</template>

<script>
import SparkMD5 from 'spark-md5'
import { randomRange, randomRangeNumber, sign } from '@/utils/validate.js'
import { parseTime } from '@/utils/formatTime'
import qs from 'qs'
import { getUploadToken, singleTransPic } from '@/api/global'
export default {
  name: 'UploadVideo',
  props: {
    value: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: '/oss-api/upload/video'
    },
    // 上传视频接口其余数据
    uploadOtherData: {
      type: Object,
      default: function () {
        return {
          fileMd5: '',
          token: '',
          source: 'saas',
          async: 0,
          appType: ''
        }
      }
    },
    // 是否可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    valueName: {
      type: String
    },
    // 允许上传大小，单位B
    size: {
      type: Number,
      default: 50 * 1024 * 1024
    },
    description: {
      type: String,
      default: '上传'
    }
  },
  data () {
    return {
      showVideoUrl: '',
      videoFlag: false, // 上传视频标志
      videoUploadPercent: 0, // 上传进度
      result: '',
      videoList: [], // 上传初始值
      isFirefox: false, // 是否是火狐浏览器，解决火狐点击已上传视频无法触发重新选择文件
      headers: {
        nonceStr: '',
        reqSerialNo: '',
        sign: '',
        version: 1
      },
      domain: 'http://t-baseweb.lepass.cn'
    }
  },
  watch: {
    value: {
      async handler (val) {
        if (this.showVideoUrl === '') {
          if (val && val.substr(0, 5) === 'video') {
            await this.getToken()
            this.result = val
            this.showVideoUrl = `${this.domain}/oss-api/download/${val}?token=${this.uploadOtherData.token}`
          } else {
            const param = qs.stringify({ path: val })
            singleTransPic(param).then(response => {
              if (response.error_code === '0') {
                this.result = val
                this.showVideoUrl = response.data.show_path
              }
            })
          }
        }
      },
      immediate: true
    }
  },
  mounted () {
    switch (process.env.CUSTOM_ENV) {
      case 'test': {
        this.domain = 'http://t-baseweb.lepass.cn/'
        break
      }
      case 'pre': {
        this.domain = 'https://web-files.leshuazf.com/'
        break
      }
      case 'prd': {
        this.domain = 'https://web-files.leshuazf.com/'
        break
      }
      default: {
        this.domain = '/t-baseweb.lepass/'
      }
    }
    console.log(this.domain)
  },
  methods: {
    getToken () {
      return new Promise((resolve, reject) => {
        getUploadToken({}).then(response => {
          if (parseInt(response.error_code) === 0) {
            this.uploadOtherData.token = response.data.token
            resolve(true)
          } else { resolve(false) }
        })
      })
    },
    async beforeUploadVideo (file) {
      // 以下对视频文件进行md5加密
      if (!await this.getToken()) {
        this.$message({
          showClose: true,
          message: '初始化失败，请重新打开',
          type: 'warning'
        })
        return
      }
      const _this = this
      return new Promise((resolve, reject) => {
        var fileReader = new FileReader()
        var dataFile = file
        var spark = new SparkMD5() // 创建md5对象（基于SparkMD5）
        // if (dataFile.size > 1024 * 1024 * 10) {
        //   var data1 = dataFile.slice(0, 1024 * 1024 * 10); //将文件进行分块 file.slice(start,length)
        //   fileReader.readAsBinaryString(data1); //将文件读取为二进制码
        // } else {
        fileReader.readAsBinaryString(dataFile)
        // }
        if (file.size > this.size) {
          const text = this.bytesToSize(this.size)
          this.$message({
            showClose: true,
            message: '视频大小不超过' + text,
            type: 'warning'
          })
          resolve(false)
        } else {
          // 文件读取完毕之后的处理
          fileReader.onload = function (e) {
            spark.appendBinary(e.target.result)
            var md5 = spark.end()
            _this.uploadOtherData.fileMd5 = md5
            const todayStr = parseTime(new Date(), '{yyy}{mm}{dd}{hh}{ii}') + randomRangeNumber(6)
            _this.headers.nonceStr = randomRange(16)
            _this.headers.reqSerialNo = todayStr
            _this.headers.sign = sign(_this.uploadOtherData, _this.headers.nonceStr)
            // console.log(_this.headers, "todayStr")
            resolve(true)
          }
        }
      })
    },
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = parseInt(file.percentage)
    },
    uploadVideo (response, file, fileList) {
      this.videoFlag = false
      this.videoUploadPercent = 0
      if (parseInt(response.respCode) !== 0) {
        this.$message({
          showClose: true,
          message: response.respMsg,
          type: 'error'
        })
      } else {
        this.result = response.data.path
        this.showVideoUrl = this.domain + `/oss-api/download/${response.data.path}?token=${this.uploadOtherData.token}`
        const data = {
          valueName: this.valueName,
          path: this.result
        }
        this.$emit('uploaded', data)
      }
    },
    bytesToSize (bytes) {
      if (bytes === 0) return '0 B'
      var k = 1024
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
    }
  }
}
</script>

<style scoped>
.uploadContent{
  width: 260px;
  height: 150px;
}
.upload {
  width: 260px;
  height: 150px;
  line-height: 150px;
  border-radius: 5px;
  background: #f0f0f0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.117647),
    0 1px 4px rgba(0, 0, 0, 0.117647);
}
.upload video {
  width: 100%;
  height: 100%;
}
</style>
